import React from "react";
import {trimString} from "helpers/helper";
import ButtonCross from "components/buttons/ButtonCross";
import ButtonDelete from "components/buttons/ButtonDelete";
import {IconDownload} from "components/icons/index";
import {saveDocument} from "helpers/helper";
import cn from "classnames";

// buttonView types: "cross", "delete"

const UploadedFilesList = ({
  files,
  viewMode,
  listBorder,
  fileBorder,
  removeFile,
  rowView,
  buttonView = "cross",
  isIconDownload,
  miniLoadFiles,
  filenameMaxViewLength = 20,
  wrapperClass,
}) => {
  const listClass = cn("editBlock_upload__links", {
    "__row-view": !!rowView,
    __border: !!listBorder,
    [wrapperClass]: !!wrapperClass,
  });
  const linkClass = cn("editBlock_upload__link", {
    "mr-2": viewMode,
    __border: !!fileBorder,
    "__mini-load-files": miniLoadFiles,
  });
  const linkProps = {className: linkClass, target: "_blank", rel: "noopener noreferrer"};
  const filenameLength = viewMode
    ? filenameMaxViewLength.view ?? 50
    : filenameMaxViewLength.edit ?? 20;

  const mapData = () => (
    <div className={listClass}>
      {files.map((file, i) => (
        <div key={file?.id ?? file?.uid ?? file?.url ?? i} className="mb-2 df-row-center">
          <a
            {...linkProps}
            href={file?.url || "#"}
            onClick={(e) => {
              if (file?.url) return;
              e.preventDefault();
              e.stopPropagation();
              saveDocument(file, file.type, file.name);
            }}
          >
            {isIconDownload && <IconDownload />}
            {trimString(file?.name, filenameLength)}
          </a>
          {buttonView === "cross" && !viewMode && (
            <ButtonCross
              addClass={`mr-${rowView ? 2 : 1}`}
              onClick={() => removeFile(i)}
            />
          )}
          {buttonView === "delete" && !viewMode && (
            <ButtonDelete
              addClass={`mr-${rowView ? 2 : 1}`}
              onClick={() => removeFile(i)}
              activeOnHover
            />
          )}
        </div>
      ))}
    </div>
  );

  return !!files?.length && mapData();
};

export default UploadedFilesList;
